import { PricingTier } from '@/pages/unauthenticated/pricing/components/types';
import { cn } from '@/lib/utils';

export const TierHeader = ({ tier }: { tier: PricingTier }) => {
  return (
    <div
      className={cn('-mt-px w-72 border-t-2 pt-10 md:w-80 border-transparent', {
        'border-primary': tier.featured,
      })}
    >
      <h3
        className={cn('text-lg font-semibold leading-6 pb-2', {
          'text-primary': tier.featured,
        })}
      >
        {tier.name}
      </h3>
      <p className="mt-1 text-sm leading-6">{tier.description}</p>
    </div>
  );
};
